module.exports = __webpack_public_path__ + "img/stay-up-to-date-94x94.a1d0f79.png";